import React, { useContext } from 'react';
import AppContext from '../context/Context';
import ParkingRoutes from '../routes/ParkingRoutes';

const ParkingLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <ParkingRoutes />
            </div>
}

export default ParkingLayout;